module.exports = __webpack_public_path__ + "img/star.5e9db182.svg";